import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationOptions } from './confirmation-dialog.models';

/** The confirmation dialog. Open it with ConfirmationDialogService.confirm(). */
@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  standalone: false,
})
export class ConfirmationDialogComponent {
  /** True while the action runs. */
  running = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly options: ConfirmationOptions,
    private readonly dialogRef: MatDialogRef<ConfirmationDialogComponent, boolean>,
    private readonly snackBar: MatSnackBar
  ) {}

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    const { action } = this.options;
    if (!action) {
      this.dialogRef.close(true);
      return;
    }
    if (this.running) {
      return;
    }
    this.running = true;
    this.dialogRef.disableClose = true;
    action().subscribe({
      error: (error) => {
        this.running = false;
        this.dialogRef.disableClose = this.options.disableClose ?? false;
        this.notify(this.errorText(error));
      },
      complete: () => {
        if (this.options.successMessage) {
          this.notify(this.options.successMessage);
        }
        this.dialogRef.close(true);
      },
    });
  }

  private errorText(error: any): string {
    const { errorMessage } = this.options;
    if (typeof errorMessage === 'function') {
      return errorMessage(error);
    }
    return errorMessage || error?.message || 'Something went wrong. Please try again.';
  }

  private notify(message: string): void {
    this.snackBar.open(message, 'Ok', { duration: 6000 });
  }
}
